import {
    PrismaRequestComment,
    prismaRequestCommentDecoder
} from './PrismaRequestComment'
import {BpsUser, bpsUserDecoder} from './BpsUser'
import {Cis2User, cis2UserDecoder} from './Cis2User'
import {Decoder, field, nullable, object} from 'json-bouncer'

export interface PrismaRequestCommentWithUsers {
    readonly prismaRequestComment: PrismaRequestComment
    readonly bpsUser: BpsUser | null
    readonly cis2User: Cis2User | null
}

export function prismaRequestCommentWithUsersDecoder(): Decoder<PrismaRequestCommentWithUsers> {
    return object({
        prismaRequestComment: field('prismaRequestComment', prismaRequestCommentDecoder()),
        bpsUser: field('bpsUser', nullable(bpsUserDecoder())),
        cis2User: field('cis2User', nullable(cis2UserDecoder())),
    })
}

export function authorName(
    {bpsUser, cis2User}: PrismaRequestCommentWithUsers,
): string {
    if (bpsUser !== null) {
        return `${bpsUser.lastName}, ${bpsUser.firstName}`
    } else if (cis2User !== null) {
        return `${cis2User.lastName}, ${cis2User.firstName}`
    } else {
        return 'Unbekannt'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestCommentWithUsers.ts